var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99958C10.5796 10.0076 11.1549 9.90034 11.6927 9.68409C12.2305 9.46783 12.7199 9.14688 13.1325 8.73987C13.5452 8.33285 13.8729 7.8479 14.0966 7.31318C14.3202 6.77845 14.4354 6.20461 14.4354 5.625C14.4354 5.04539 14.3202 4.47155 14.0966 3.93682C13.8729 3.4021 13.5452 2.91714 13.1325 2.51013C12.7199 2.10312 12.2305 1.78217 11.6927 1.56591C11.1549 1.34966 10.5796 1.24242 10 1.25042C8.85025 1.26629 7.75296 1.73416 6.94551 2.55283C6.13807 3.3715 5.68538 4.47514 5.68538 5.625C5.68538 6.77486 6.13807 7.8785 6.94551 8.69717C7.75296 9.51584 8.85025 9.98371 10 9.99958ZM10 11.2496C7.28833 11.2496 1.875 12.9246 1.875 16.2496V18.7496H18.125V16.2496C18.125 12.9246 12.7117 11.2496 10 11.2496Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.77c725bffee1bc496ce9ff616fbae5ea.svg";
export { ForwardRef as ReactComponent };